<template>
  <div class="home">
    <div class="container bg-black m-auto splash">
      <img
        class="splash-logo m-auto"
        alt="Let's try to get is straight before we change it"
        src="@/assets/images/icon.svg"
      />
    </div>

    <div
      class="home-content container m-auto flex flex-col lg:flex-row border-black border-l-4 border-r-4 p-6"
    >
      <div
        class="cell2 lg:order-2 lg:w-1/3 pb-6 mb-6 border-gray border-b lg:border-b-0 lg:border-r"
        aria-hidden="true"
      >
        <p
          class="text-primary text-center font-bold text-2xl mt-1 lg:text-3xl xl:text-4xl lg:p-10"
        >
          Let's try to get it straight <em>before</em> we try to change it
        </p>
      </div>

      <div
        class="cell1 text-lg lg:order-1 lg:w-1/3 pb-6 mb-6 border-gray border-b lg:border-b-0 lg:border-r lg:p-6"
      >
        <h2>What is Scrum?</h2>

        <p class="mb-3">
          Scrum is an agile framework designed to turn complex goals into
          steady, predictable results. By focusing small, dedicated teams on
          short delivery cycles, Scrum makes progress visible, priorities
          adaptable, and customer value continuous&mdash;not an afterthought at
          the end of a long timeline.
        </p>

        <h2>What we can do for you</h2>
        <ul class="list-disc m-2">
          <li class="text-lg mb-2">
            Diagnose, Measure &amp; Improve your Organizational Culture
          </li>
          <li class="text-lg mb-2">
            Enhance Leadership skills within your organization
          </li>
          <li class="text-lg mb-2">
            Transition your organization from Project to Product
          </li>
          <li class="text-lg mb-2">
            Improve your Product Agility practices at the organization, team
            &amp; role levels
          </li>
        </ul>
      </div>

      <div class="cell3 lg:order-3 lg:w-1/3 lg:p-6">
        <SSLatestBlogPost />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import SSLatestBlogPost from "@/components/SSLatestBlogPost.vue";

export default {
  name: "Home",
  components: {
    SSLatestBlogPost
  }
};
</script>

<style scoped lang="scss">
.splash {
  height: 250px;
  position: relative;
}
.splash-logo {
  width: 300px;
  position: absolute;
  bottom: -50px;
  left: 50%;
  margin-left: -150px;
}

.home-content {
  h2 {
    @apply font-bold;
  }
}
</style>
